import styled from 'styled-components';
import { useTranslation } from '@klv/hooks/useTranslation';

import TextLink from '@klv/atoms/text-link';
import Typography from '@klv/atoms/typography';
import { useModal } from '@klv/context/modal';
import type { ICTALegalLanguage } from './types';


const StyledLegalLanguage = styled(Typography)`
  color: var(--color-white);
  margin-top: 2rem;
`;
const TermsSection = styled(Typography)`
  margin-bottom: 20px;
`;
const CTALegalLanguage = ({ formType, ...props }: ICTALegalLanguage) => {
  const { t } = useTranslation();
  const colorVariant = props.colorVariant || 'light';
  const modalStore = useModal();
  const notSupportedLocale = ['fr'].includes(t('langCodes_pathPrefix'));

  return (
    <StyledLegalLanguage {...props} variant="formSmall">
      {((formType === 'signup') || (formType === 'demo' && !notSupportedLocale)) && (
        <TermsSection colorVariant={colorVariant} variant="formRegular">
          {t('organisms_forms_legal_acknowledgement')}
          {' '}
          {formType !== 'demo' &&
            <><TextLink $colorVariant={colorVariant} tabIndex={0} href={t('organisms_forms_legal_termsOfService_href')} target='_blank' onClick={() => modalStore.close()}>{t('organisms_forms_legal_termsOfService')}</TextLink>
              {' '}
              {t('organisms_forms_legal_and')}
              {' '}
            </>}
          <TextLink tabIndex={0} href={t('organisms_forms_legal_privacyPolicy_href')} target='_blank' onClick={() => modalStore.close()}>{t('organisms_forms_legal_privacyPolicy_label')}</TextLink>
          .
        </TermsSection>
      )}

      {(formType === 'demo' && t('langCodes_pathPrefix') === 'fr') && (
        <TermsSection colorVariant={colorVariant} variant="formRegular">
          {t('organisms_forms_legal_agreeToTermsOfService')} {' '}
          <TextLink $colorVariant={colorVariant} tabIndex={0} href={t('organisms_forms_legal_termsOfService_href')} target='_blank' onClick={() => modalStore.close()}>{t('organisms_forms_legal_agreeTermsLinkText')}</TextLink>
          {' '}
          {t('organisms_forms_legal_and')}
          {' '}
          <TextLink $colorVariant={colorVariant} tabIndex={0} href={t('organisms_forms_legal_codeOfConduct_href')} target='_blank' onClick={() => modalStore.close()}>{t('organisms_forms_legal_agreeToPartnerCodeOfConduct')}</TextLink>
        </TermsSection>
      )}
    </StyledLegalLanguage>
  );
};

export default CTALegalLanguage;
